import React from "react";
import { useNavigate } from "react-router-dom";

export default function Footer() {
  const navigate = useNavigate();
  return (
    <footer>
      <div class="container">
        <div class="row g-5">
          <div class="col-lg-6">
            <div class="footer-section">
              <h3>About easyILA</h3>
              <div class="animate-on-scroll">
                <div class="d-flex align-items-center mb-3">
                  <i class="fas fa-check-circle fa-2x text-accent me-3"></i>
                  <p class="mb-0">Request Initial Consultation With Lawyer</p>
                </div>
                <div class="d-flex align-items-center mb-3">
                  <i class="fas fa-check-circle fa-2x text-accent me-3"></i>
                  <p class="mb-0">Built-In Document Checklists</p>
                </div>
                <div class="d-flex align-items-center mb-3">
                  <i class="fas fa-check-circle fa-2x text-accent me-3"></i>
                  <p class="mb-0">
                    Reliable, Cost-Effective, and Precise Solutions
                  </p>
                </div>
                <div class="d-flex align-items-center">
                  <i class="fas fa-check-circle fa-2x text-accent me-3"></i>
                  <p class="mb-0">Human & Automation support</p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-6 footerboxes">
            <div class="footer-section">
              <h3>Contact Us</h3>
              {/* <p><i class="fas fa-map-marker-alt me-2"></i> 123 Immigration Way, New York, NY 10001</p> */}
              <p>
                <i class="fas fa-phone me-2"></i> (475) 655-0977
              </p>
              <p>
                <i class="fas fa-envelope me-2"></i> support@easyila.com
              </p>
              <p>
                <i class="fas fa-clock me-2"></i> Mon-Fri: 9AM - 6PM EST
              </p>
              <div class="social-links mt-4">
                <a
                  href="https://www.facebook.com/easyila"
                  target="_blank"
                  aria-label="icon"
                >
                  <i class="fab fa-facebook-f"></i>
                </a>
                <a
                  href="https://www.instagram.com/easyila_services/"
                  target="_blank"
                  aria-label="icon"
                >
                  <i class="fab fa-instagram"></i>
                </a>
                <a
                  href="https://www.linkedin.com/company/easyila/"
                  target="_blank"
                  aria-label="icon"
                >
                  <i class="fab fa-linkedin-in"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="copyright text-center mt-5 pt-4">
          <p>
            &copy; DISCLAIMER IN PART: (
            <span
              onClick={() => navigate("/disclaimer")}
              style={{
                fontWeight: "bold",
                cursor: "pointer",
                color: "var(--accent)",
              }}
            >
              Read full Disclaimer here
            </span>
            ) : This site is not a substitute for hiring an attorney or law firm
            and does not provide legal advice. This site does not endorse or
            recommend any participating third-party legal professionals that pay
            to participate in advertising. An attorney-client relationship is
            not formed when calling the number on this site or filling out a
            form. Services may not be available for all legal categories. All
            persons depicted in a photo or video are actors or models or from
            unsplash.com and not clients of any firm. WE ARE NOT A LEGAL FIRM OR
            AN ACCREDITED ORGANIZATION. ALL IMMIGRATION MATTERS SHOULD BE
            CONSULTED WITH IMMIGRATION ATTORNEYS OR AS GUIDED BY USCIS FROM TIME
            TO TIME. WE DO NOT REPRESENT USCIS. WE DO NOT GIVE ANY ADVICE,
            OPINION, OR CONSULTANCY ON IMMIGRATION MATTERS.
          </p>
          {/* <p class="mb-0">All copyrights reserved © 2025 - easyILA</p> */}
        </div>
      </div>
    </footer>
  );
}
